module.exports = __webpack_public_path__ + "images/solent-7549a018ff1fbecdde3fc823b5682902.jpg";